module.exports = __webpack_public_path__ + "img/banner3.6200cfaf.jpg";